module.exports = __webpack_public_path__ + "media/images/pages/fcr/doctor-4-5b5e6e38c586aad90accac7df715478c.png";